import { render, staticRenderFns } from "./ToggleBlockAction.vue?vue&type=template&id=441c083d&scoped=true&"
import script from "./ToggleBlockAction.vue?vue&type=script&lang=js&"
export * from "./ToggleBlockAction.vue?vue&type=script&lang=js&"
import style0 from "./ToggleBlockAction.vue?vue&type=style&index=0&id=441c083d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441c083d",
  null
  
)

export default component.exports